import React, {Component} from 'react';
import {Form, Formik, ErrorMessage} from 'formik';
import classes from './GeneralFormComponent.module.scss';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import {
    FormField, IGalleryField, IInputField, IDropdownField, IMultipleSelectField
} from '../FormFields/formFields';
import InputField from '../FormFields/InputField/InputField';
import {ObjectSchema} from 'yup';
import Directives from '../../Directives/Directives';
import GalleryField from '../FormFields/GalleryField/GalleryField';
import DropdownField from '../FormFields/DropdownField/DropdownField';
import Typography from '@material-ui/core/Typography';
import {Prompt} from 'react-router';
import CircularProgress from '@material-ui/core/CircularProgress';
import MultipleSelectField from "../FormFields/multipleSelectField/multipleSelectField";

interface IProps {
    formTitle: string;
    fields: FormField[];
    formSchema: ObjectSchema<any>;
    onChangeValues?: (key: any, value: any) => void;
    submitButton?: {
        title: string;
        onSubmit(values: any): void;
    };
    cancelButton?: {
        title: string;
        onCancel(): void;
    };
    processing: boolean;
    isDeal?: boolean;
}

class GeneralFormComponent extends Component<IProps, any> {

    constructor(props: IProps) {
        super(props);
        const constructedState = {} as any;
        for (let field of this.props.fields) {
            if (field.filedType === 'InputField') {
                constructedState[field.name] = field.value ? field.value : '';
            } else if (field.filedType === 'GalleryField') {
                constructedState[field.name] = field.value ? field.value : [];
            } else if (field.filedType === 'MultipleSelectField') {
                constructedState[field.name] = field.value ? field.value : [];
            } else {
                constructedState[field.name] = field.value;
            }
        }
        constructedState.formChanged = false;
        this.state = constructedState;
    }

    handleSubmit = (values: any) => {
        this.setState({formChanged: false});
    }

    handleChange = (prop: any) => (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        this.setState({[prop]: event.target.value});
        this.setState({
            formChanged: true
        });
        if (this.props.onChangeValues) {
            this.props.onChangeValues!(prop, event.target.value);
        }
    }
    handleDropdownChange = (prop: any) => (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        this.setState({[prop]: event.target.value});
        this.setState({
            formChanged: true
        });
        if (this.props.onChangeValues) {
            this.props.onChangeValues!(prop, event.target.value);
        }
    }
    getMultipleSelectField = (field: IMultipleSelectField, errors: any, touched: any, index: number): any => {
        return <MultipleSelectField onChange={this.handleMultipleSelectChange}
                                    errors={errors}
                                    touched={touched}
                                    filedType={field.filedType}
                                    name={field.name}
                                    selectListKey={field.selectListKey}
                                    selectListValue={field.selectListValue}
                                    selectList={field.selectList}
                                    label={field.label}
                                    value={this.state[ field.name ]}
                                    key={index}/>;
    }
    handleMultipleSelectChange = (prop: any) => (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        // console.log(prop);
        // console.log(event.target.value);
        this.setState({ [prop]: event.target.value });
        this.setState({
            formChanged: true
        });
        if (this.props.onChangeValues) {
            this.props.onChangeValues!(prop, event.target.value);
        }
    }
    handleAddImageToGallery = (prop: any, imageFile: File) => {
        const oldGallery = this.state[prop] || [];
        const file = Object.assign(imageFile, {
            preview: URL.createObjectURL(imageFile),
        });
        oldGallery.push(file);
        this.setState({[prop]: oldGallery});
        this.setState({
            formChanged: true
        });
        if (this.props.onChangeValues) {
            this.props.onChangeValues!(prop, oldGallery);
        }
    }

    handleAddImageToGalleryInCaseOfLimit = (prop: any, imageFile: File) => {
        const file = Object.assign(imageFile, {
            preview: URL.createObjectURL(imageFile),
        });
        this.setState({
            [prop]: [file]
        });
        this.setState({
            formChanged: true
        });
        if (this.props.onChangeValues) {
            this.props.onChangeValues!(prop, [file]);
        }
    }

    handleDeleteImageFromGallery = (prop: any, imageIndex: number) => {
        const oldGallery = this.state[prop] || [];
        oldGallery.splice(imageIndex, 1);
        this.setState({[prop]: oldGallery});
        this.setState({
            formChanged: true
        });
        if (this.props.onChangeValues) {
            this.props.onChangeValues!(prop, oldGallery);
        }
    }

    getInputField = (field: IInputField, errors: any, touched: any, index: number): any => {
        return <InputField onChange={this.handleChange}
                           errors={errors}
                           touched={touched}
                           filedType={field.filedType}
                           name={field.name}
                           label={field.label}
                           type={field.type}
                           multiLine={(!!field.multiLine)}
                           rowsMax={(field.rowsMax)}
                           value={this.state[field.name]}
                           suffix={field.suffix}
                           disabled={!!field.disabled}
                           key={index}/>;
    }

    getGalleryField = (field: IGalleryField, errors: any, touched: any, index: number): any => {
        return <GalleryField
            onAddImage={field.isLimitToOneImage ? this.handleAddImageToGalleryInCaseOfLimit : this.handleAddImageToGallery}
            onRemoveImage={this.handleDeleteImageFromGallery}
            filedType={field.filedType}
            name={field.name}
            errors={errors}
            touched={touched}
            value={this.state[field.name]}
            accept={field.accept}
            label={field.label}
            isLimitToOneImage={field.isLimitToOneImage}
            textMessage={field.textMessage}
            warningMessage={field.warningMessage}
            key={index}
            ratio={field.ratio}/>;
    }
    getDropdownField = (field: IDropdownField, errors: any, touched: any, index: number): any => {
        return <DropdownField onChange={this.handleDropdownChange}
                              errors={errors}
                              touched={touched}
                              filedType={field.filedType}
                              name={field.name}
                              selectListKey={field.selectListKey}
                              selectListValue={field.selectListValue}
                              selectList={field.selectList}
                              label={field.label}
                              value={this.state[field.name]}
                              key={index}/>;
    }

    getField = (field: FormField, errors: any, touched: any, index: number): any => {
        if (field.filedType === 'InputField') {
            return this.getInputField(field as IInputField, errors, touched, index);
        }
        if (field.filedType === 'GalleryField') {
            return this.getGalleryField(field as IGalleryField, errors, touched, index);
        }
        if (field.filedType === 'MultipleSelectField') {
            return this.getMultipleSelectField(field as IMultipleSelectField, errors, touched, index);
        }
        if (field.filedType === 'DropdownField') {
            return this.getDropdownField(field as IDropdownField, errors, touched, index);
        }
        return '';
    }

    revokeImageGallery(field: any) {
        if (field) {
            field.forEach((image: any) => {
                if (image.preview) {
                    URL.revokeObjectURL(image.preview);
                }
            });
        }
    }

    componentWillUnmount() {
        // Make sure to revoke the data uris to avoid memory leaks
        for (let field of this.props.fields) {
            if (field.filedType === 'GalleryField') {
                this.revokeImageGallery(this.state[field.name]);
            }
        }
    }

    render() {
        const initialValues = {} as any;
        for (let field of this.props.fields) {
            initialValues[field.name] = this.state[field.name];
        }
        return (
            <div className={classes.mainCard}>
                <Typography variant='subtitle1' gutterBottom className={classNames(classes.title)}>
                    {this.props.formTitle}
                </Typography>

                <Prompt
                    when={this.state.formChanged}
                    message='You have unsaved changes, Are you sure you want to leave this page?'>
                </Prompt>

                <Formik
                    enableReinitialize={true}
                    initialValues={initialValues}
                    validationSchema={this.props.formSchema}
                    onSubmit={values => {
                        if (this.props.submitButton) {
                            this.props.submitButton!.onSubmit(values);
                        }
                        this.handleSubmit(values);
                    }}
                >
                    {({errors, touched, values}) => {
                        let filterFields = this.props.fields;
                        if(values.item && this.props.isDeal){
                            filterFields = this.props.fields.filter(f => f.name !== 'category' && f.name !== 'discount');
                        }
                        if(values.category && this.props.isDeal){
                            filterFields = this.props.fields.filter(f => f.name !== 'item');
                        }
                        return (
                            <div className={classes.card}>
                                <Form className={classes.form}>
                                    {
                                        filterFields.map((ele, index) => this.getField(ele, errors, touched, index))
                                    }
                                    <div className={classes.actions}>
                                        <Directives dIf={this.props.submitButton}>
                                            <div className={classes.submitBox}>
                                                <Button variant='contained'
                                                        className={classes.submit}
                                                        color='primary'
                                                        disabled={this.props.processing}
                                                        type='submit'>
                                                    {this.props.submitButton ? this.props.submitButton.title : ''}
                                                </Button>
                                                {this.props.processing && <CircularProgress size={24} color='primary'
                                                                                            className={classes.buttonProgress}/>}
                                            </div>
                                        </Directives>
                                        <Directives dIf={this.props.cancelButton}>
                                            <Button variant='outlined'
                                                    style={{margin: 0, fontSize: '14px', fontWeight: 'bold'}}
                                                    color='primary'
                                                    onClick={() => this.props.cancelButton!.onCancel()}
                                                    type='button'>
                                                {this.props.cancelButton ? this.props.cancelButton.title : ''}
                                            </Button>
                                        </Directives>
                                    </div>
                                </Form>
                            </div>
                        );
                    }
                    }
                </Formik>
            </div>)
    }
}

export default GeneralFormComponent;